import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const blogSlice = createSlice({
  name: "blog",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addBlog: (state, action) => {
      state.data.push(action.payload);
    },
    setBlog: (state, action) => {
      const index = state.data.findIndex(
        (blog) => blog._id === action.payload._id
      );
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    removeBlog: (state, action) => {
      state.data = state.data.filter((post) => post._id !== action.payload);
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  addBlog,
  setBlog,
  removeBlog,
} = blogSlice.actions;

export default blogSlice.reducer;

export const fetchBlogs = () => async (dispatch) => {
  try {
    dispatch(fetchStart());

    const res = await axios.get("/private/backend/blog");

    dispatch(fetchSuccess(res.data));
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    dispatch(fetchFailure(errorMessage));
  }
};

export const createBlog = (payload) => async (dispatch) => {
  try {
    const res = await axios.post("/private/backend/blog", payload);

    dispatch(addBlog(res.data));
    toast.success("Blog created successfully");
    return true;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return false;
  }
};

export const updateBlog = (payload, id) => async (dispatch) => {
  try {
    const res = await axios.put("/private/backend/blog/" + id, payload);

    dispatch(setBlog(res.data));
    toast.success("Blog created successfully");
    return true;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return false;
  }
};

export const deleteBlog = (id) => async (dispatch) => {
  try {
    const res = await axios.delete("/private/backend/blog/" + id);

    dispatch(removeBlog(id));
    toast.success("Blog created successfully");
    return true;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return false;
  }
};
